import { render, staticRenderFns } from "./TopCharts.vue?vue&type=template&id=5dbf043a&scoped=true"
import script from "./TopCharts.vue?vue&type=script&lang=ts"
export * from "./TopCharts.vue?vue&type=script&lang=ts"
import style0 from "./TopCharts.vue?vue&type=style&index=0&id=5dbf043a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf043a",
  null
  
)

export default component.exports